<div
  class="card card-nc"
  *ngIf="hasEntitlement('REGISTER_SHIP') && shipsContact && showRegister"
>
  <div class="card-heading">
    <i class="fa fa-ship"></i>
    <span class="cardHeaderHeading"> Register New Ship </span>
  </div>
  <div class="card-body">
    <form name="newShipForm" [formGroup]="newShipForm" (ngSubmit)="onSubmit()">
      <div class="card card-nc">
        <div class="card-heading">
          <i class="fa fa-ship"></i>
          <span class="cardHeaderHeading"> Ship Registration Information </span>
        </div>
        <div class="card-body">
          <div formGroupName="ship">
            <div class="row">
              <div class="col-md-3">
                <div class="row rightLeftPad">
                  <label
                    for="shipLocation"
                    class="col-md-12 control-label labelCommon"
                  >
                    *Location
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      formControlName="location"
                      class="form-control input-sm"
                      [ngClass]="{
                        'has-error':
                          !newShipForm.get('ship.location').valid &&
                          newShipForm.get('ship.location').touched
                      }"
                      id="shipLocation"
                      minLength="6"
                      maxlength="6"
                      pattern="[a-zA-Z0-9]*"
                    />
                    <span
                      *ngIf="
                        !newShipForm.get('ship.location').valid &&
                        newShipForm.get('ship.location').touched
                      "
                    >
                      <span
                        *ngIf="
                          newShipForm.get('ship.location').errors[
                            'locationTooShort'
                          ]
                        "
                        class="help-block has-error validationMessage"
                      >
                        Location should be a 6 digit alpha numeric (ex. E23123)
                      </span>
                      <span
                        class="help-block has-error validationMessage"
                        *ngIf="
                          newShipForm.get('ship.location').errors['required']
                        "
                      >
                        Required
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="row rightLeftPad">
                  <label
                    for="shipName"
                    class="col-md-12 control-label labelCommon"
                  >
                    *Ship Name
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      formControlName="name"
                      [ngClass]="{
                        'has-error':
                          !newShipForm.get('ship.name').valid &&
                          newShipForm.get('ship.name').touched
                      }"
                      class="form-control input-sm"
                      id="shipName"
                      maxlength="100"
                    />
                    <span
                      *ngIf="
                        !newShipForm.get('ship.name').valid &&
                        newShipForm.get('ship.name').touched"
                    >
                      <span
                        *ngIf="
                          newShipForm.get('ship.name').errors['required']"
                        class="help-block has-error validationMessage">
                        Required
                      </span>
                      <span
                        *ngIf="
                          newShipForm.get('ship.name').errors['invalidShipName']"
                        class="help-block has-error validationMessage">
                        Only alphabets,numbers,-,',",. are allowed for ship name
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="row rightLeftPad">
                  <label
                    for="shipHull"
                    class="col-md-12 control-label labelCommon"
                  >
                    *Hull
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      formControlName="hull"
                      [ngClass]="{
                        'has-error':
                          !newShipForm.get('ship.hull').valid &&
                          newShipForm.get('ship.hull').touched
                      }"
                      class="form-control input-sm"
                      id="shipHull"
                      maxlength="8"
                    />
                    <span
                      *ngIf="
                        !newShipForm.get('ship.hull').valid &&
                        newShipForm.get('ship.hull').touched
                      "
                      class="help-block has-error validationMessage"
                      ><span
                        *ngIf="newShipForm.get('ship.hull').errors['pattern']"
                        class="help-block has-error validationMessage"
                      >
                        Only alphabets and numbers are allowed
                      </span>
                      <span
                        *ngIf="newShipForm.get('ship.hull').errors['required']"
                      >
                        Required
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="row rightLeftPad">
                  <label
                    for="shipClass"
                    class="col-md-12 control-label labelCommon"
                  >
                    *Class
                  </label>
                  <div class="form-group col-md-12">
                    <select
                      formControlName="shipClass"
                      class="form-control input-sm"
                      [ngClass]="{
                        'has-error':
                          !newShipForm.get('ship.shipClass').valid &&
                          newShipForm.get('ship.shipClass').touched
                      }"
                      id="shipClass"
                    >
                      <option value="" selected>Please Select...</option>
                      <option
                        *ngFor="let shipClass of shipClasses"
                        [value]="shipClass"
                        >{{ shipClass }}</option
                      >
                    </select>
                    <span
                      *ngIf="
                        !newShipForm.get('ship.shipClass').valid &&
                        newShipForm.get('ship.shipClass').touched &&
                        newShipForm.get('ship.shipClass').errors['required']
                      "
                      class="help-block has-error validationMessage"
                    >
                      Required
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="row rightLeftPad">
                  <label
                    for="crewSize"
                    class="col-md-12 control-label labelCommon"
                  >
                    *Crew Size
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      formControlName="crewSize"
                      [ngClass]="{
                        'has-error':
                          !newShipForm.get('ship.crewSize').valid &&
                          newShipForm.get('ship.crewSize').touched
                      }"
                      class="form-control input-sm"
                      id="crewSize"
                      maxlength="4"
                    />
                    <span
                      *ngIf="
                        !newShipForm.get('ship.crewSize').valid &&
                        newShipForm.get('ship.crewSize').touched
                      "
                      class="help-block has-error validationMessage"
                      ><span
                        *ngIf="
                          newShipForm.get('ship.crewSize').errors['pattern']
                        "
                      >
                        Only numbers are allowed
                      </span>
                      <span
                        *ngIf="
                          newShipForm.get('ship.crewSize').errors['required']
                        "
                      >
                        Required
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card card-nc">
        <div class="card-heading">
          <i class="fa fa-ship"></i>
          <span class="cardHeaderHeading"> Fleet Information </span>
        </div>
        <div class="card-body">
          <div formGroupName="fleet">
            <div class="row">
              <div class="col-md-2">
                <div class="row rightLeftPad">
                  <label
                    for="shipPort"
                    class="col-md-12 control-label labelCommon"
                  >
                    *Home Port
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      formControlName="port"
                      type="text"
                      class="form-control input-sm"
                      [ngClass]="{
                        'has-error':
                          !newShipForm.get('fleet.port').valid &&
                          newShipForm.get('fleet.port').touched
                      }"
                      id="shipPort"
                      maxlength="100"
                    />
                    <span
                      *ngIf="
                        !newShipForm.get('fleet.port').valid &&
                        newShipForm.get('fleet.port').touched
                      "
                      class="help-block has-error validationMessage"
                    >
                      <span
                        *ngIf="
                          newShipForm.get('fleet.port').errors[
                            'invalidHomePort'
                          ]
                        "
                      >
                        Only alphabets,numbers,-,. are allowed for home port
                      </span>
                      <span
                        *ngIf="newShipForm.get('fleet.port').errors['required']"
                      >
                        Required
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="row rightLeftPad">
                  <label for="dssn" class="col-md-12 control-label labelCommon">
                    *DSSN
                  </label>
                  <div class="form-group col-md-12">
                    <input
                      type="text"
                      formControlName="dssn"
                      [ngClass]="{
                        'has-error':
                          !newShipForm.get('fleet.dssn').valid &&
                          newShipForm.get('fleet.dssn').touched
                      }"
                      class="form-control input-sm"
                      id="dssn"
                      maxlength="4"
                    />
                    <span
                      *ngIf="
                        !newShipForm.get('fleet.dssn').valid &&
                        newShipForm.get('fleet.dssn').touched
                      "
                      class="help-block has-error validationMessage"
                      ><span
                        *ngIf="newShipForm.get('fleet.dssn').errors['pattern']"
                      >
                        Only numbers are allowed
                      </span>
                      <span
                        *ngIf="newShipForm.get('fleet.dssn').errors['required']"
                      >
                        Required
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="row rightLeftPad">
                  <label
                    for="marineDssn"
                    class="col-md-12 control-label labelCommon"
                  >
                    Marine DSSN
                  </label>
                  <div class="form-group col-md-12">
                    <select
                      formControlName="marineDssn"
                      class="form-control input-sm"
                      [ngClass]="{
                        'has-error':
                          !newShipForm.get('fleet.marineDssn').valid &&
                          newShipForm.get('fleet.marineDssn').touched
                      }"
                      id="marineDssn"
                    >
                      <option value="" selected>Please Select...</option>
                      <option value="">N/A</option>
                      <option
                        *ngFor="let marineDssn of marineDssnCodes"
                        [value]="marineDssn"
                        >{{ marineDssn }}</option
                      >
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="row rightLeftPad">
                  <label
                    for="shipTycom"
                    class="col-md-12 control-label labelCommon"
                  >
                    *TYCOM
                  </label>
                  <div class="form-group col-md-12">
                    <select
                      formControlName="tycom"
                      class="form-control input-sm"
                      [ngClass]="{
                        'has-error':
                          !newShipForm.get('fleet.tycom').valid &&
                          newShipForm.get('fleet.tycom').touched
                      }"
                      id="tycom"
                    >
                      <option value="" selected>Please Select...</option>
                      <option value="N/A">N/A</option>
                      <option
                        *ngFor="let tycom of tycomCodes"
                        [value]="tycom"
                        >{{ tycom }}</option
                      >
                    </select>
                    <span
                      *ngIf="
                        !newShipForm.get('fleet.tycom').valid &&
                        newShipForm.get('fleet.tycom').touched &&
                        newShipForm.get('fleet.tycom').errors['required']
                      "
                      class="help-block has-error validationMessage"
                    >
                      Required
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="row rightLeftPad">
                  <label
                    for="shipCinc"
                    class="col-md-12 control-label labelCommon"
                  >
                    *CINC
                  </label>
                  <div class="form-group col-md-12">
                    <select
                      formControlName="cinc"
                      class="form-control input-sm"
                      [ngClass]="{
                        'has-error':
                          !newShipForm.get('fleet.cinc').valid &&
                          newShipForm.get('fleet.cinc').touched
                      }"
                      id="cinc"
                    >
                      <option value="" select>Please Select...</option>
                      <option value="N/A">N/A</option>
                      <option *ngFor="let cinc of cincCodes" [value]="cinc">{{
                        cinc
                      }}</option>
                    </select>
                    <span
                      *ngIf="
                        !newShipForm.get('fleet.cinc').valid &&
                        newShipForm.get('fleet.cinc').touched &&
                        newShipForm.get('fleet.cinc').errors['required']
                      "
                      class="help-block has-error validationMessage"
                    >
                      Required
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card card-nc">
        <div class="card-heading">
          <i class="icon-NC_contact"></i>
          <span class="cardHeaderHeading"> Disbursing Office </span>
        </div>
        <div class="card-body">
          <div formGroupName="disbo">
            <div class="row">
              <div class="col-md-4">
                <label
                  for="disboName"
                  class="col-md-12 control-label labelCommon"
                >
                  Officer
                </label>
                <div class="form-group col-md-12">
                  <input
                    formControlName="officer"
                    type="text"
                    class="form-control input-sm"
                    [ngClass]="{
                      'has-error':
                        !newShipForm.get('disbo.officer').valid &&
                        newShipForm.get('disbo.officer').touched
                    }"
                    id="disboName"
                    maxlength="50"
                  />
                  <span
                    *ngIf="
                      !newShipForm.get('disbo.officer').valid &&
                      newShipForm.get('disbo.officer').touched
                    "
                  >
                    <span
                      *ngIf="
                        newShipForm.get('disbo.officer').errors[
                          'invalidDisboName'
                        ]
                      "
                      class="help-block has-error validationMessage"
                    >
                      Enter a valid Officer Name.
                    </span>
                    <span
                      class="help-block has-error validationMessage"
                      *ngIf="
                        newShipForm.get('disbo.officer').errors['required']
                      "
                    >
                      Required
                    </span>
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <label
                  for="disboPhone"
                  class="col-md-12 control-label labelCommon"
                >
                  Phone
                </label>
                <div class="form-group col-md-12">
                  <input
                    formControlName="phone"
                    type="text"
                    class="form-control input-sm"
                    [ngClass]="{
                      'has-error':
                        !newShipForm.get('disbo.phone').valid &&
                        newShipForm.get('disbo.phone').touched
                    }"
                    id="disboPhone"
                    maxlength="14"
                  />
                  <span
                    *ngIf="
                      !newShipForm.get('disbo.phone').valid &&
                      newShipForm.get('disbo.phone').touched &&
                      newShipForm.get('disbo.phone').errors['invalidPhone']
                    "
                    class="help-block has-error validationMessage"
                  >
                    Only numbers allowed
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <label
                  for="disboEmail"
                  class="col-md-12 control-label labelCommon"
                >
                  Email
                </label>
                <div class="form-group col-md-12">
                  <input
                    formControlName="email"
                    type="text"
                    class="form-control input-sm"
                    [ngClass]="{
                      'has-error':
                        !newShipForm.get('disbo.email').valid &&
                        newShipForm.get('disbo.email').touched
                    }"
                    id="disboEmail"
                    maxlength="50"
                  />
                  <span
                    *ngIf="
                      !newShipForm.get('disbo.email').valid &&
                      newShipForm.get('disbo.email').touched
                    "
                    class="help-block has-error validationMessage"
                  >
                    Enter a valid disbo email
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card card-nc">
        <div class="card-heading">
          <i class="icon-NC_contact"></i>
          <span class="cardHeaderHeading"> LSR Contact </span>
        </div>
        <div class="card-body">
          <div formGroupName="lsr">
            <div class="row">
              <div class="col-md-4">
                <label
                  for="lsrContact"
                  class="col-md-12 control-label labelCommon"
                >
                  Contact
                </label>
                <div class="form-group col-md-12">
                  <input
                    formControlName="contact"
                    type="text"
                    class="form-control input-sm"
                    [ngClass]="{
                      'has-error':
                        !newShipForm.get('lsr.contact').valid &&
                        newShipForm.get('lsr.contact').touched
                    }"
                    id="lsrContact"
                    maxlength="100"
                  />
                  <span
                    *ngIf="
                      !newShipForm.get('lsr.contact').valid &&
                      newShipForm.get('lsr.contact').touched &&
                      newShipForm.get('lsr.contact').errors['invalidLsrContact']
                    "
                    class="help-block has-error validationMessage"
                  >
                    Enter a valid lsr Contact.
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <label
                  for="lsrPhone"
                  class="col-md-12 control-label labelCommon"
                >
                  LSR Phone
                </label>
                <div class="form-group col-md-12">
                  <input
                    formControlName="phone"
                    type="text"
                    class="form-control input-sm"
                    [ngClass]="{
                      'has-error':
                        !newShipForm.get('lsr.phone').valid &&
                        newShipForm.get('lsr.phone').touched
                    }"
                    id="lsrPhone"
                    maxlength="14"
                  />
                  <span
                    *ngIf="
                      !newShipForm.get('lsr.phone').valid &&
                      newShipForm.get('lsr.phone').touched &&
                      newShipForm.get('lsr.phone').errors['invalidPhone']
                    "
                    class="help-block has-error validationMessage"
                  >
                    Only numbers allowed
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card card-nc">
        <div class="card-heading">
          <i class="fa fa-home"></i>
          <span class="cardHeaderHeading"> Ship Address </span>
        </div>
        <div class="card-body">
          <div formGroupName="shipaddr">
            <div class="row">
              <div class="form-group col-md-12" style="margin-bottom: 15px;">
                <span class="labelCommon">The ship address is used for open loop purchases with PNC.</span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12" style="margin-bottom: 15px;">
                <span class="labelCommon">*Address</span><br />
                <input
                  formControlName="address1"
                  type="text"
                  class="form-control input-sm"
                  [ngClass]="{
                    'has-error':
                      !newShipForm.get('shipaddr.address1').valid &&
                      newShipForm.get('shipaddr.address1').touched
                  }"
                  id="addressLine1"
                  maxlength="34"
                />
                <span
                  *ngIf="
                    !newShipForm.get('shipaddr.address1').valid &&
                    newShipForm.get('shipaddr.address1').touched
                  "
                  class="help-block has-error validationMessage"
                >
                  <span
                    *ngIf="newShipForm.get('shipaddr.address1').errors['pattern']"
                  >
                    Must be letters, numbers, spaces or dashes
                  </span>
                  <span *ngIf="newShipForm.get('shipaddr.address1').errors['required']">
                    Required
                  </span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6" style="margin-bottom: 15px;">
                <input
                  formControlName="address2"
                  type="text"
                  class="form-control input-sm"
                  id="addressLine2"
                  maxlength="34"
                /><span
                  *ngIf="
                    !newShipForm.get('shipaddr.address2').valid &&
                    newShipForm.get('shipaddr.address2').touched
                  "
                  class="help-block has-error validationMessage"
                >
                  <span
                    *ngIf="newShipForm.get('shipaddr.address2').errors['pattern']"
                  >
                    Must be letters, numbers, spaces or dashes
                  </span>
                </span>
              </div>
              <div class="form-group col-md-6" style="margin-bottom: 15px;">
                <input
                  formControlName="address3"
                  type="text"
                  class="form-control input-sm"
                  id="addressLine3"
                  maxlength="34"
                /><span
                  *ngIf="
                    !newShipForm.get('shipaddr.address3').valid &&
                    newShipForm.get('shipaddr.address3').touched
                  "
                  class="help-block has-error validationMessage"
                >
                  <span
                    *ngIf="newShipForm.get('shipaddr.address3').errors['pattern']"
                  >
                    Must be letters, numbers, spaces or dashes
                  </span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-4">
                <span class="labelCommon">*City</span><br />
                <input
                  formControlName="city"
                  type="text"
                  class="form-control input-sm"
                  [ngClass]="{
                    'has-error':
                      !newShipForm.get('shipaddr.city').valid &&
                      newShipForm.get('shipaddr.city').touched
                  }"
                  id="city"
                  maxlength="34"
                /><span
                  *ngIf="
                    !newShipForm.get('shipaddr.city').valid &&
                    newShipForm.get('shipaddr.city').touched
                  "
                  class="help-block has-error validationMessage"
                >
                  <span *ngIf="newShipForm.get('shipaddr.city').errors['pattern']">
                    Must be letters, spaces or dashes
                  </span>
                  <span *ngIf="newShipForm.get('shipaddr.city').errors['required']">
                    Required
                  </span>
                </span>
              </div>
              <div class="form-group col-md-4">
                <span class="labelCommon">*State</span><br />
                <select
                  formControlName="state"
                  class="form-control input-sm"
                  [ngClass]="{
                    'has-error':
                      !newShipForm.get('shipaddr.state').valid &&
                      newShipForm.get('shipaddr.state').touched
                  }"
                  id="state"
                >
                  <option
                    *ngFor="let state of shipsContact.states"
                    [value]="state"
                    >{{ state }}</option
                  >
                </select>
                <span
                  *ngIf="
                    !newShipForm.get('shipaddr.state').valid &&
                    newShipForm.get('shipaddr.state').touched &&
                    newShipForm.get('shipaddr.state').errors['required']
                  "
                  class="help-block has-error validationMessage"
                >
                  Required
                </span>
              </div>
              <div class="form-group col-md-4">
                <span class="labelCommon">*Zip</span><br />
                <input
                  formControlName="zip"
                  type="text"
                  class="form-control input-sm"
                  [ngClass]="{
                    'has-error':
                      !newShipForm.get('shipaddr.zip').valid &&
                      newShipForm.get('shipaddr.zip').touched
                  }"
                  id="zip"
                  maxlength="10"
                />
                <span
                  *ngIf="
                    !newShipForm.get('shipaddr.zip').valid &&
                    newShipForm.get('shipaddr.zip').touched
                  "
                  class="help-block has-error validationMessage"
                >
                  <span *ngIf="newShipForm.get('shipaddr.zip').errors['pattern']">
                    Please enter a valid Zip
                  </span>
                  <span *ngIf="newShipForm.get('shipaddr.zip').errors['required']">
                    Required
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card card-nc">
        <div class="card-heading">
          <i class="fa fa-home"></i>
          <span class="cardHeaderHeading"> Bulk Mailing Address </span>
        </div>
        <div class="card-body">
          <div formGroupName="bulk">
            <div class="row">
              <div class="form-group col-md-12" style="margin-bottom: 15px;">
                <span class="labelCommon">The bulk mailing address is used on the Fedex or USPS mailing label to deliver bulk card orders to NAVSUP.</span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6" style="margin-bottom: 15px;">
                <span class="labelCommon">*Contact Name</span><br />
                <input
                  formControlName="contactName"
                  type="text"
                  class="form-control input-sm"
                  id="contactName"
                  maxlength="50"/>
                  <span
                    *ngIf="
                      !newShipForm.get('bulk.contactName').valid &&
                      newShipForm.get('bulk.contactName').touched &&
                      newShipForm.get('bulk.contactName').errors['required']"
                    class="help-block has-error validationMessage">
                    Required
                  </span>
              </div>
              <div class="form-group col-md-6" style="margin-bottom: 15px;">
                <span class="labelCommon">Company</span><br />
                <input
                  formControlName="company"
                  type="text"
                  class="form-control input-sm"
                  id="company"
                  maxlength="30"/>
                <span
                  *ngIf="
                    !newShipForm.get('bulk.company').valid &&
                    newShipForm.get('bulk.company').touched &&
                    newShipForm.get('bulk.company').errors['required']"
                  class="help-block has-error validationMessage">
                  Required
                </span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-12" style="margin-bottom: 15px;">
                <span class="labelCommon">*Address</span><br />
                <input
                  formControlName="address1"
                  type="text"
                  class="form-control input-sm"
                  [ngClass]="{
                    'has-error':
                      !newShipForm.get('bulk.address1').valid &&
                      newShipForm.get('bulk.address1').touched
                  }"
                  id="emvAddressLine1"
                  maxlength="34"
                />
                <span
                  *ngIf="
                    !newShipForm.get('bulk.address1').valid &&
                    newShipForm.get('bulk.address1').touched
                  "
                  class="help-block has-error validationMessage"
                >
                  <span
                    *ngIf="newShipForm.get('bulk.address1').errors['pattern']"
                  >
                    Must be letters, numbers, spaces or dashes
                  </span>
                  <span
                    *ngIf="newShipForm.get('bulk.address1').errors['required']"
                  >
                    Required
                  </span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-6" style="margin-bottom: 15px;">
                <input
                  formControlName="address2"
                  type="text"
                  class="form-control input-sm"
                  id="emvAddressLine2"
                  maxlength="34"
                /><span
                  *ngIf="
                    !newShipForm.get('bulk.address2').valid &&
                    newShipForm.get('bulk.address2').touched
                  "
                  class="help-block has-error validationMessage"
                >
                  <span
                    *ngIf="newShipForm.get('bulk.address2').errors['pattern']"
                  >
                    Must be letters, numbers, spaces or dashes
                  </span>
                </span>
              </div>
              <div class="form-group col-md-6" style="margin-bottom: 15px;">
                <input
                  formControlName="address3"
                  type="text"
                  class="form-control input-sm"
                  id="emvAddressLine3"
                  maxlength="34"
                /><span
                  *ngIf="
                    !newShipForm.get('bulk.address3').valid &&
                    newShipForm.get('bulk.address3').touched
                  "
                  class="help-block has-error validationMessage"
                >
                  <span
                    *ngIf="newShipForm.get('bulk.address3').errors['pattern']"
                  >
                    Must be letters, numbers, spaces or dashes
                  </span>
                </span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-3">
                <span class="labelCommon">*City</span><br />
                <input
                  formControlName="city"
                  type="text"
                  class="form-control input-sm"
                  [ngClass]="{
                    'has-error':
                      !newShipForm.get('bulk.city').valid &&
                      newShipForm.get('bulk.city').touched
                  }"
                  id="emvCity"
                  maxlength="34"
                /><span
                  *ngIf="
                    !newShipForm.get('bulk.city').valid &&
                    newShipForm.get('bulk.city').touched
                  "
                  class="help-block has-error validationMessage"
                >
                  <span *ngIf="newShipForm.get('bulk.city').errors['pattern']">
                    Must be letters, spaces or dashes
                  </span>
                  <span *ngIf="newShipForm.get('bulk.city').errors['required']">
                    Required
                  </span>
                </span>
              </div>
              <div class="form-group col-md-3">
                <span class="labelCommon">*State</span><br />
                <select
                  formControlName="state"
                  class="form-control input-sm"
                  [ngClass]="{
                    'has-error':
                      !newShipForm.get('bulk.state').valid &&
                      newShipForm.get('bulk.state').touched
                  }"
                  id="emvState"
                >
                  <option
                    *ngFor="let state of shipsContact.states"
                    [value]="state"
                    >{{ state }}</option
                  >
                </select>
                <span
                  *ngIf="
                    !newShipForm.get('bulk.state').valid &&
                    newShipForm.get('bulk.state').touched &&
                    newShipForm.get('bulk.state').errors['required']
                  "
                  class="help-block has-error validationMessage"
                >
                  Required
                </span>
              </div>
              <div class="form-group col-md-2">
                <span class="labelCommon">*Zip</span><br />
                <input
                  formControlName="zip"
                  type="text"
                  class="form-control input-sm"
                  [ngClass]="{
                    'has-error':
                      !newShipForm.get('bulk.zip').valid &&
                      newShipForm.get('bulk.zip').touched
                  }"
                  id="emvZip"
                  maxlength="10"
                />
                <span
                  *ngIf="
                    !newShipForm.get('bulk.zip').valid &&
                    newShipForm.get('bulk.zip').touched
                  "
                  class="help-block has-error validationMessage"
                >
                  <span *ngIf="newShipForm.get('bulk.zip').errors['pattern']">
                    Please enter a valid Zip
                  </span>
                  <span *ngIf="newShipForm.get('bulk.zip').errors['required']">
                    Required
                  </span>
                </span>
              </div>
              <div class="form-group col-md-2">
                <span class="labelCommon">*Country</span><br>
                <select
                  class="form-control input-sm"
                  id="country"
                  formControlName="country"
                  [(ngModel)]="defaultCountry">
                  <option *ngFor="let country of shipsContact.countries"
                          [value]="country">{{country}}</option>
                </select>
                <span
                  *ngIf="!newShipForm.get('bulk.country').valid &&
                    newShipForm.get('bulk.country').touched &&
                    newShipForm.get('bulk.country').errors['required']"
                  class="help-block has-error validationMessage">
                  Required
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card-body" style="padding-top: 30px; padding-bottom: 30px;">
        <h6 class="card-title">
          <span class="pull-right save-panel">
            &nbsp;
            <button
              *ngIf="showRegister"
              type="button"
              (click)="register()"
              class="btn btn-nc"
              style="margin-right: 5px;"
            >
              NEXT
              <i [class]="save_ba_btn_spinner"></i>
            </button>
            <button
              *ngIf="showRegister"
              type="button"
              (click)="onCancel()"
              class="btn cancel-btn"
            >
              CANCEL
              <i ng-class="save_ba_btn_spinner"></i>
            </button>
          </span>
        </h6>
      </div>
    </form>
  </div>
</div>
<div *ngIf="showMerchants">
  <app-ship-register-merchants
    [ship]="this.createShipFromForm()"
    (registerCancel)="showMerchants = false; showRegister = true"
  >
  </app-ship-register-merchants>
</div>
